import {
  IField_Filestore_Type,
} from '../types/storage'

import {
  API_URL,
  STORAGE_BUCKET_PREFIX,
} from '../constants'

import globalEnv from '../utils/globalEnv'

export const getPrefix = () => {
  return globalEnv.GOOGLE_STORAGE_BUCKET_PREFIX || STORAGE_BUCKET_PREFIX
}

export const getUrl = (path: string): string => `${API_URL}${path}`

export const getProjectUrl = (project: string, path = '') => {
  return getUrl(`/project/${project}`) + path
}

export const getFilestoreUploadUrl = (project: string, org: string, filestoreType: IField_Filestore_Type) => {
  return getProjectUrl(project, `/filestore/${org}/${filestoreType}`)
}

export const getFilestoreDownloadUrl = (project: string, org: string, filestoreType: IField_Filestore_Type) => {
  return getProjectUrl(project, `/filestore/${org}/${filestoreType}/file`)
}

export const getFilestoreMediaUrl = (project: string) => {
  return getProjectUrl(project, `/filestore/media`)
}

export const constructUrl = (url: string, query: Record<string, any> = {}): string => {
  const parts = Object.keys(query).map(key => `${key}=${encodeURIComponent(query[key])}`)
  return url + (parts.length > 0 ? '?' + parts.join('&') : '')
}